import { useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'

function useAuthority(userAuthority = [], authority = [], emptyCheck = false) {
    const roleMatched = useMemo(() => {
        if (!Array.isArray(userAuthority) || !Array.isArray(authority)) {
            return false
        }
        if (userAuthority.includes('*')) {
            return true
        }
        return authority.some((role) => userAuthority.includes(role))
    }, [authority, userAuthority])

    if (isEmpty(authority) || typeof authority === 'undefined') {
        return !emptyCheck
    }

    if (isEmpty(userAuthority)) {
        return false
    }

    return roleMatched
}

export default useAuthority
